"use strict";module.exports = {
  toggleDetails: function toggleDetails(ev) {
    this.emit('toggle', { originalEvent: ev, open: this.getEl('root').open });
  },
  clickDetails: function clickDetails(ev) {
    this.emit('click', { originalEvent: ev });
  } };